module.exports = __webpack_public_path__ + "static/img/ginger_pictgrid4_800x653.3371628.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ginger_pictgrid4_800x653.jpg
// module id = uCDD
// module chunks = 0